import { Button, dialog } from "nq-component";
import React, { Component } from "react";
import {
  upsertUseCase,
  findObjectUseCase,
} from "../../../../../../../usecases/object";
import { FloatingForm } from "../../../../../../../components/common/Converter";
import CardView from "../../../../../../../components/common/CardView";
import SearchSelect from "../../../../../../../components/searchSelect/SearchSelect";
import InputFactory from "../../../../../../../components/InputFactory";
import BaseFormPage from "../../../../../../../base/BaseFormPage";
import AllowanceBeniFormPresenter from "./AllowanceBeniFormPresenter";

export default class AllowanceBeniFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new AllowanceBeniFormPresenter(this);
    this.state = {
      objectID: "",
      id: this.props.data.id,
      selectedAllowance: this.props.data.allowance || "",
      amount: this.props.data.amount || "",
      taxable: this.props.data.taxable || "",
      excessAmount: this.props.data.excessAmount || "",
    };
  }

  getCollectionName() {
    return "allowances";
  }

  async handleSave() {
    try {
      const { id, selectedAllowance, amount, taxable, excessAmount } =
        this.state;

      let storedObject =
        JSON.parse(sessionStorage.getItem("allowanceObject")) || [];

      console.log("storedObject", storedObject);

      const query = {
        where: {
          id: id,
        },
      };

      console.log("QUERRYYY", query);
      const employees = await findObjectUseCase().execute("allowances", query);

      if (employees && employees.length > 0) {
        const [employeeData] = employees;
        const updateData = {
          ...employeeData,
          allowance: selectedAllowance,
          amount: amount,
          taxable: taxable,
          excessAmount: excessAmount,
        };

        await upsertUseCase().execute("allowances", updateData);

        // Update sessionStorage if an item with the same id exists
      } else if (storedObject && Array.isArray(storedObject)) {
        const updated = storedObject.map((item) =>
          item.id === id
            ? {
                ...item,
                id: id,
                allowance: selectedAllowance,
                amount: String(amount),
                taxable: taxable,
              }
            : item
        );

        console.log("updated", updated);
        sessionStorage.setItem("allowanceObject", JSON.stringify(updated));
        console.log("sessionStorage updated successfully");
      } else {
        console.log("not found");
      }

      this.showSuccess("Data Successfully Updated");
      this.props.closeModal();
      this.props.refetchData();
    } catch (error) {
      console.error(
        "An error occurred while handling enroll button click:",
        error
      );
    }
  }

  hanldeAllowanceChange(selectedAllowance) {
    this.setState({ selectedAllowance });
  }
  hanldeAmountChange(amount) {
    this.setState({ amount });
  }
  hanldeTaxableChange(taxable) {
    this.setState({ taxable });
  }

  onchangeExcess(excessAmount) {
    this.setState({ excessAmount });
  }

  handleCancel = () => {
    this.props.closeModal();
  };

  render() {
    const tax = ["YES", "NO"];
    return (
      <>
        <FloatingForm width="50%">
          <CardView>
            {" "}
            <h4 className="p-2">Edit Allowances</h4>
            <hr></hr>
            <div className=" d-flex row  p-3 gap-2">
              <label>Allowance Type</label>
              <div className="col-md-12  ">
                <InputFactory
                  type="String"
                  value={this.state.selectedAllowance}
                  onChange={this.hanldeAllowanceChange.bind(this)}
                  disabled={true}
                />
              </div>
              <label>Amount</label>
              <div className="col-md-12 ">
                <InputFactory
                  type="Number"
                  // _type="parseNumber"
                  value={this.state.amount || ""}
                  onChange={this.hanldeAmountChange.bind(this)}
                />
              </div>
              <label>Maximum-Non Taxable</label>
              <div className="col-md-12 ">
                <SearchSelect
                  value={this.state.taxable}
                  onClickClear={() => {
                    this.hanldeTaxableChange("");
                  }}
                  onChange={this.hanldeTaxableChange.bind(this)}
                  options={tax.map((type) => ({
                    label: type,
                    value: type,
                  }))}
                />
              </div>

              {this.state.taxable === "YES" && (
                <>
                  <label>Excess Amount</label>
                  <div className="col-md-12">
                    <InputFactory
                      type="Number"
                      field="excessAmount"
                      value={this.state.excessAmount || ""}
                      onChange={(value) => this.onchangeExcess(value)}
                    />
                  </div>
                </>
              )}
              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <hr></hr>
                <Button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleSave.bind(this)}
                >
                  Save
                </Button>
                <Button className="btn btn-light" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </div>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
